<template lang="pug">
  v-flex(xs12 md4 data-cy="finish-create-campaign-action")
    v-flex.xs12
      div.headline Do you want to add another action to this campaign?
    v-flex.pt-2.xs6
      v-btn.ml-0.small.primary(@click="handleNewAction") Add Another Action
    v-flex.pt-2.xs6
      v-btn.ml-0.small.flat(@click="handleBack") Finish and Exit
</template>
<script>
export default {
  props: {
    /**
     * Callback function to handle clicking back
     */
    handleBack: Function,
    /**
     * Callback function to handle creating a new action
     */
    handleNewAction: Function,
  },
};

</script>

